/** Nomi delle code BullMQ e payload dei job — condivisi tra api e worker. */

export const QUEUE_EMAIL = "email";

/** Natura dell'email: separa il transazionale dal marketing nel log. */
export const EMAIL_CATEGORIES = ["transactional", "marketing"] as const;
export type EmailCategory = (typeof EMAIL_CATEGORIES)[number];

/** Chi ha innescato l'invio. */
export const EMAIL_ACTOR_TYPES = ["user", "system", "automation", "contact"] as const;
export type EmailActorType = (typeof EMAIL_ACTOR_TYPES)[number];

/** Stato di consegna registrato in email_log. */
export const EMAIL_LOG_STATUSES = ["queued", "sent", "failed", "skipped"] as const;
export type EmailLogStatus = (typeof EMAIL_LOG_STATUSES)[number];

/** Azioni note che generano email (elenco aperto: il campo resta testuale). */
export const EMAIL_ACTIONS = [
  "auth.welcome",
  "auth.password_reset",
  "tenant.invite_sent",
  "quote.sent",
  "billing.trial_reminder",
  "billing.trial_expired",
  "marketing.campaign",
  "marketing.automation",
  "marketing.contact_email",
] as const;
export type EmailAction = (typeof EMAIL_ACTIONS)[number];

export interface EmailJobPayload {
  to: string;
  subject: string;
  html: string;
  /**
   * Tenant il cui mittente configurato (Impostazioni → Invio email) va usato
   * per la consegna. Il worker ricarica la configurazione dal DB al momento
   * dell'invio (SMTP del tenant o DKIM per-tenant); se assente o non
   * verificata, l'email esce dal mittente di piattaforma.
   */
  senderTenantId?: string;
  /** Alternativa testuale: se assente viene generata dall'HTML in sendEmail(). */
  text?: string;
  /** Casella a cui rispondere; default MAIL_REPLY_TO. */
  replyTo?: string;
  /**
   * URL di disiscrizione one-click. Diventa gli header `List-Unsubscribe`
   * e `List-Unsubscribe-Post`, richiesti da Gmail/Yahoo sugli invii massivi.
   */
  listUnsubscribe?: string;
  /** Header SMTP aggiuntivi. */
  headers?: Record<string, string>;
  /** Riga di email_log da aggiornare con l'esito reale dell'invio. */
  logId?: string;
}
